const SERVICE = "market/order";

const listOrder = async (api, status, params) =>
  api
    .setMethod()
    .get()
    .setService(SERVICE)
    .process(`/status/${status}`, params);

const getOrder = async (api, orderId) =>
  api.setMethod().get().setService(SERVICE).process(`/${orderId}`);

const cancelOrder = async (api, orderId) =>
  api.setMethod().post().setService(SERVICE).process(`/cancel/${orderId}`);

const receivedOrder = async (api, orderId) =>
  api.setMethod().post().setService(SERVICE).process(`/receive/${orderId}`);

module.exports = {
  listOrder,
  getOrder,
  cancelOrder,
  receivedOrder,
};
